import { SetActiveOrganization, SetLastOrganizationId } from '@/constants/mutations';
import { ChangeActiveOrganization, FetchUserData, GetPlansQuota, OrgEnsured } from '@/constants/actions';
import { GetLastOrganizationId } from '@/constants/getters';

export default async function ({ $auth, store, error, route }) {
  const strategy = $auth.strategy;
  const user = $auth.user;

  if (strategy.token.status().valid() && route.path !== $auth.options?.redirect?.callback) {
    const userData = await store.dispatch(`authStore/${FetchUserData}`);
    const organizations = userData?.organizations ?? [];

    if (!organizations.length) {
      error({ statusCode: 403 });

      return Promise.resolve();
    }

    // Check if the active user is already authenticated in the context of an organization;
    if (!user.org_id) {
      const lastOrganizationId = store.getters[`authStore/${GetLastOrganizationId}`](userData.id);
      const setActiveOrganization = organizations.find((org) => org.id === lastOrganizationId) ?? organizations[0];

      return store.dispatch(`authStore/${ChangeActiveOrganization}`, {
        organizationId: setActiveOrganization.id,
        auth0Id: setActiveOrganization.auth0Id,
      });
    }

    // Check if the active user has not been removed from the active organization;
    const activeOrganization = organizations.find((org) => org.auth0Id === user.org_id);

    if (!activeOrganization) {
      error({ statusCode: 403 });

      return Promise.resolve();
    }

    store.dispatch(`authStore/${SetActiveOrganization}`, activeOrganization.id);
    store.dispatch(`authStore/${SetLastOrganizationId}`, activeOrganization.id);

    await store.dispatch(`authStore/${GetPlansQuota}`);

    store.dispatch(`authStore/${OrgEnsured}`);
  }

  return Promise.resolve();
}
